import apiClient from './api'

function cleanParams(params = {}) {
  const result = {}
  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return
    if (typeof value === 'string' && value.trim() === '') return
    result[key] = value
  })
  return result
}

export async function listCurrencyTransitionRules(params = {}) {
  const response = await apiClient.get('/admin/currency-transition-rules', {
    params: cleanParams(params),
  })
  return Array.isArray(response.data?.data) ? response.data.data : []
}

export async function getCurrencyTransitionRule(id) {
  const response = await apiClient.get(`/admin/currency-transition-rules/${id}`)
  return response.data?.data || null
}

export async function createCurrencyTransitionRule(payload) {
  const response = await apiClient.post('/admin/currency-transition-rules', payload)
  return response.data?.data || null
}

export async function updateCurrencyTransitionRule(id, payload) {
  const response = await apiClient.patch(`/admin/currency-transition-rules/${id}`, payload)
  return response.data?.data || null
}

export async function disableCurrencyTransitionRule(id) {
  const response = await apiClient.post(`/admin/currency-transition-rules/${id}/disable`)
  return response.data?.data || null
}

const currencyTransitionRuleService = {
  listCurrencyTransitionRules,
  getCurrencyTransitionRule,
  createCurrencyTransitionRule,
  updateCurrencyTransitionRule,
  disableCurrencyTransitionRule,
}

export default currencyTransitionRuleService
